<template>
  <div class="right-box">
    <div class="publisher-box">
      <h3>发布者</h3>
      <div class="img-box" @click="goBkOrBj">
        <img
          v-if="autherInfo.headImg"
          :src="`${$global.imgUrl}${autherInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/xuezhe.png" alt="" />
      </div>
      <p class="name" @click="goBkOrBj">{{autherInfo.name}}</p>
      <div class="num-box">
        <div style="text-align: center;">
          <p class="num">{{number.thesisCount}}</p>
          <p class="label">文献数</p>
        </div>
        <div style="text-align: center;">
          <p class="num">{{number.informationCount}}</p>
          <p class="label">资讯数</p>
        </div>
      </div>
    </div>
    <div class="related-box">
      <h3>最新会议</h3>
      <div class="related-list">
        <div class="list-item" v-for="item in relatedList" :key="item.id">
          <span style="cursor: pointer;" @click="toDetail(item.id)" v-html="item.title"></span>
        </div>
      </div>
    </div>
    <div class="navigation">
      <ul>
        <li :style="{color:state == 1 ? '#4585F5' : '#333333'}" @click="tz(1)">会议信息</li>
        <li v-if="detailsData.data.open === 1" :style="{color:state == 2 ? '#4585F5' : '#333333'}" @click="tz(2)">报名</li>
        <li :style="{color:state == 3 ? '#4585F5' : '#333333'}" @click="tz(3)">会议介绍</li>
        <li :style="{color:state == 4 ? '#4585F5' : '#333333'}" @click="tz(4)" v-if="detailsData.data.committees && detailsData.data.committees.length > 0">组委会</li>
        <li :style="{color:state == 5 ? '#4585F5' : '#333333'}" @click="tz(5)" v-if="(detailsData.data.edits && detailsData.data.edits.length > 0) || detailsData.data.solicitContent">征稿信息</li>
        <li :style="{color:state == 6 ? '#4585F5' : '#333333'}" @click="tz(6)" v-if="detailsData.data.imgVideos.some((item)=>item.type === 1)">会议图片</li>
        <li :style="{color:state == 7 ? '#4585F5' : '#333333'}" @click="tz(7)" v-if="detailsData.data.imgVideos.some((item)=>item.type === 2)">会议视频</li>
      </ul>
    </div>
    <div class="linkman" v-if="detailsData.data.contactsName && detailsData.data.contactsInfo">
      <div class="h">会议联系人</div>
      <div>{{detailsData.data.contactsName}}</div>
      <div>{{detailsData.data.contactsInfo}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "right",
  data(){
    return{
      state:1
    }
  },
  props: [
    "detailsData",
    "autherInfo",
    "relatedList",
    "number"
  ],
  methods: {
    // 百科/机构号跳转
    goBkOrBj() {
      if (this.detailsData.data.userType === 2) {
        let routeUrl = this.$router.resolve({
          path: `/jghdetail`,
          query: {
            title: "机构号",
            id: this.detailsData.data.companyId,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/bkzxdetail`,
          query: {
            title: "百科在线",
            id: this.detailsData.data.companyId
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 最新会议跳转
    toDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "meetingDetails",
        query: {
          id,
          type: 8
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 锚点跳转
    tz(id) {
      switch (id) {
        case 1:
          let anchorTagOne = document.getElementById('anchorTagOne')
          this.ToDrawSome(anchorTagOne,id)
          break;
        case 2:
          let anchorTagTwo = document.getElementById('anchorTagTwo')
          this.ToDrawSome(anchorTagTwo,id)
          break;
        case 3:
          let anchorTagThree = document.getElementById('anchorTagThree')
          this.ToDrawSome(anchorTagThree,id)
          break;
        case 4:
          let anchorTagFour = document.getElementById('anchorTagFour')
          this.ToDrawSome(anchorTagFour,id)
          break;
        case 5:
          let anchorTagFive = document.getElementById('anchorTagFive')
          this.ToDrawSome(anchorTagFive,id)
          break;
        case 6:
          let anchorTagSix = document.getElementById('anchorTagSix')
          this.ToDrawSome(anchorTagSix,id)
          break;
        case 7:
          let anchorTagSeven = document.getElementById('anchorTagSeven')
          this.ToDrawSome(anchorTagSeven,id)
          break;
      }
    },
    // 描点跳转封
    ToDrawSome(M,id) {
      let el = document.documentElement
      el.scrollTop = M.offsetTop - 120
      this.state = id
    }
  },
};
</script>

<style lang="scss" scoped>
  .right-box {
    margin-left: 10px;
    flex: 1;
  }
  .publisher-box {
    margin-bottom: 30px;
    padding: 20px 25px;
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #A3CBE7;
    border-radius: 10px;
    h3 {
      margin-bottom: 10px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .img-box {
      margin: 0 auto 15px;
      overflow: hidden;
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .name {
      margin-bottom: 50px;
      text-align: center;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      cursor: pointer;
    }
    .num-box {
      display: flex;
      justify-content: space-around;
      .label {
        margin-right: 5px;
        font-size: 12px;
        font-family: PingFang SC;
        color: #666666;
      }
      .num {
        font-size: 24px;
        font-family: TypoPRO;
        color: #FF7D14;
      }
    }
  }
  .related-box {
    h3 {
      padding-left: 30px;
      height: 40px;
      line-height: 18px;
      border-bottom: 1px solid #E5E5E5;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    .related-list {
      padding: 28px 20px 0;
      .list-item {
        margin-bottom: 15px;
        padding-bottom: 18px;
        padding-left: 10px;
        width: 100%;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        border-bottom: 1px dashed #E8E8E8;
      }
    }
  }
  .navigation{
    margin-bottom: 30px;
    padding: 20px 25px;
    width: 100%;
    background: #FAFAFA;
    border-radius: 10px;
    li{
      cursor:pointer;
      margin: 5px 0;
      margin-left: 20px;
      color: #333;
      list-style-type:disc;
    }
  }
  .linkman{
    margin-bottom: 30px;
    padding: 20px 25px;
    width: 100%;
    background: #FAFAFA;
    border-radius: 10px;
    font-weight: bold;
    .h{
      font-size: 18px;
      color: #333;
      margin-bottom: 10px;
    }
  }
</style>
